<template>
   <div>
     <Widget>
       <b-row >
         <b-col>
           <h3><b>{{user.doctor.name }}</b></h3>
         </b-col>
         <b-col style="margin-left: 50%; margin-top: 3px;">
           <b-button pill variant="outline-success" @click="setmodal">Edit</b-button>
         </b-col>
       </b-row>
       <hr><hr>
       <span class="mb-2"><h5>Pending Amount : {{user.doctor.pending_amount}}</h5></span>
       <table class="table">
         <tbody>
         <tr>
           <th>Type :</th>
           <td class="table-data">{{getDoctorType(this.user.doctor.doctortype_id)}}</td>
         </tr>
         <tr>
           <th>Work Place/Office :</th>
           <td class="table-data">{{this.user.doctor.workplace}}</td>
         </tr>
         <tr>
           <th>Designation :</th>
           <td class="table-data">{{this.user.doctor.designation}}</td>
         </tr>
         <tr>
           <th>BMDC Number :</th>
           <td class="table-data">{{this.user.doctor.bmdc_number}}</td>
         </tr>
         <tr>
           <th>Medical College :</th>
           <td class="table-data">{{JSON.parse(this.user.doctor.medical_college).name}}</td>
         </tr>
         <tr>
           <th>Session :</th>
           <td class="table-data">{{JSON.parse(this.user.doctor.medical_college).session}}</td>
         </tr>
         <tr>
           <th>Batch :</th>
           <td class="table-data">{{JSON.parse(this.user.doctor.medical_college).batch}}</td>
         </tr>
         </tbody>
       </table>
       <h6>Payments</h6>
       <table class="table">
         <tbody>
         <tr>
           <th>Rate :</th>
           <td>{{this.user.doctor.rate}}</td>
         </tr>
         <tr>
           <th>Offer Rate :</th>
           <td>{{this.user.doctor.offer_rate}}</td>
         </tr>
         <tr>
           <th>Report Followup Rate :</th>
           <td>{{this.user.doctor.report_followup_rate}}</td>
         </tr>
         <tr>
           <th>Followup Rate:</th>
           <td>{{this.user.doctor.followup_rate}}</td>
         </tr>
         <tr>
           <th>Commission :</th>
           <td>{{this.user.doctor.commission*100}}%</td>
         </tr>
         </tbody>
       </table>
       <h6>PerSonal Informations</h6>
       <table class="table">
         <tbody>
         <tr>
           <th>Mobile :</th>
           <td class="table-data">{{this.user.mobile}}</td>
         </tr>
         <tr>
           <th>Email :</th>
           <td class="table-data">{{this.user.doctor.email}}</td>
         </tr>
         <tr>
           <th>Gender :</th>
           <td class="table-data">{{this.user.doctor.gender===0 ? 'Male' : 'Female'}}</td>
         </tr>
         </tbody>
       </table>
     </Widget>


     <b-modal id="edit-modal" v-model="showEditModal" centered title="Ekhoni Daktar" @ok="submitEditForm" >
       <b-form-group id="workplace_group" label="Work Place/Office :" label-for="workplace" >
         <b-form-input id="workplace" v-model="edit_form.workplace" type="text"></b-form-input>
       </b-form-group>
       <b-form-group id="designation_group" label="Designation :" label-for="designation" >
         <b-form-input id="designation" v-model="edit_form.designation" type="text"></b-form-input>
       </b-form-group>
       <b-form-group id="other_trainings_group" label="Other Trainings :" label-for="other_trainings">
         <b-form-input id="other_trainings" v-model="edit_form.other_trainings" type="text"></b-form-input>
       </b-form-group>

       <b-form-group id="commission" label="Commission percentage %:" label-for="commission">
         <b-form-input id="commission" v-model="edit_form.commission" type="number"></b-form-input>
       </b-form-group>
       <b-row>
         <b-col>
           <b-form-group id="rate_group" label="Rate :" label-for="rate">
             <b-form-input id="rate" v-model="edit_form.rate" type="number"></b-form-input>
           </b-form-group>
         </b-col>
         <b-col>
           <b-form-group id="offer_rate_group" label="Offer Rate :" label-for="offer_rate">
             <b-form-input id="offer_rate" v-model="edit_form.offer_rate" type="number"></b-form-input>
           </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
           <b-form-group id="followup_rate_group" label="Followup Rate :" label-for="followup_rate">
             <b-form-input id="followup_rate" v-model="edit_form.followup_rate" type="number"></b-form-input>
           </b-form-group>
         </b-col>
         <b-col>
           <b-form-group id="report_followup_rate_group" label="Report Followup Rate :" label-for="report_followup_rate">
             <b-form-input id="report_followup_rate" v-model="edit_form.report_followup_rate" type="number"></b-form-input>
           </b-form-group>
         </b-col>
       </b-row>
     </b-modal>
   </div>
</template>

<script>
import {mapGetters} from "vuex";
import {Form} from "vform";
import DoctorService from "@/services/admin/doctor.service"

export default {
  name: "DoctorDetailsTable",
  props:['user'],
  data() {
    return {
      showEditModal: false,
      edit_form: new Form(
          {
            commission: this.user.doctor.commission * 100,
            rate: this.user.doctor.rate,
            offer_rate: this.user.doctor.offer_rate,
            followup_rate: this.user.doctor.followup_rate,
            report_followup_rate: this.user.doctor.report_followup_rate,
            workplace: this.user.doctor.workplace,
            designation: this.user.doctor.designation,
            other_trainings: this.user.doctor.other_trainings,
          }
      ),
    };
  },
  computed:{
    ...mapGetters('adminAuth', ['getdoctortype']),
  },
  methods:{
    setmodal(){
      this.edit_form.fill(this.user.doctor);
      this.showEditModal=true;
    },
    getDoctorType(doctortype_id){
      var type=null;
      this.getdoctortype.forEach(e =>{
        if(e.id===doctortype_id){
          type = e.name;
        }
      })
      return type;
    },
    submitEditForm(){
      DoctorService.updateDoctorInfo(this.edit_form,this.user.doctor.id)
          .then((resposne) => {
            this.showEditModal = false;
            if (resposne.status === 204) {
              this.$toasted.info("Information Updated", {
                theme: "bubble",
                position: "top-right",
                duration: 3000,
                icon: 'check',
              });
              // this.storeUser(resposne.data);
            }
          })
          .catch(()=>{
            this.$toasted.info("Information Updated Failed", {
              theme: "toasted-danger",
              position: "top-right",
              duration: 3000,
              icon: 'cross',
            });
          })
    }
  },
}
</script>

<style scoped>

</style>
